import { ICommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { APTerm } from '../../../global/builders/ap_term_builder';
import { ISaveTermPayload } from '../../../global/components/course_tile_menu/course_tile_course_menu';
import { INVALID_ID } from '../../../global/constants/ap_id_constants';
import { DEEMPHASIZE_DROP_AREA, EMPHASIZE_DROP_AREA } from '../../../plan/constants/event_names';
interface IDndData {
  slotId: number;
  plannedCourseId: number;
  courseId: number;
  isFromTerm: true;
  slotType: string;
  courseGroupId: number;
}
angular.module('capability-ng-academic-planner');

export class TermBoxMm {
  private term: APTerm;
  private isPast: boolean;
  private isEmptyTerm = true;
  private dropList = [];
  private draggingGenericSlot: any = undefined;
  private isDropAreaActive: boolean = false;
  private emphasizeDropAreaBound: () => void;
  private deEmphasizeDropAreaBound: () => void;
  constructor(
    private saveMmCourseToTermCommand: ICommand,
    private loadMmAcademicPlanCommand: ICommand,
    private $timeout: ng.ITimeoutService,
    private saveMmCourseGroupToTermCommand: ICommand,
    private removeMmCourseFromTermCommand: ICommand,
    private removeMmCourseGroupFromTermCommand: ICommand,
    private ngComponentCommunicatorService: CommunicatorService
  ) {}

  $onInit() {
    this.emphasizeDropAreaBound = this.emphasizeDropArea.bind(this);
    this.deEmphasizeDropAreaBound = this.deEmphasizeDropArea.bind(this);
    this.ngComponentCommunicatorService.subscribe(EMPHASIZE_DROP_AREA, this.emphasizeDropAreaBound);
    this.ngComponentCommunicatorService.subscribe(DEEMPHASIZE_DROP_AREA, this.deEmphasizeDropAreaBound);
    this.initialize();
  }
  $onChanges(changes: any) {
    this.initialize();
  }
  toggleDragState() {
    if (this.isPast) {
      return;
    }
    this.$timeout(() => angular.element('body').toggleClass('dnd-course-delete'), 0);
  }
  dragStarted(course: any) {
    this.draggingGenericSlot = course;
    this.ngComponentCommunicatorService.publish(EMPHASIZE_DROP_AREA);
    this.toggleDragState();
  }
  dragCompleted() {
    this.draggingGenericSlot = undefined;
    this.ngComponentCommunicatorService.publish(DEEMPHASIZE_DROP_AREA);
    this.toggleDragState();
  }

  emphasizeDropArea() {
    if (!_4.isUndefined(this.draggingGenericSlot) || this.isPast) {
      return;
    }
    this.isDropAreaActive = true;
  }
  deEmphasizeDropArea() {
    this.isDropAreaActive = false;
  }
  dndData(_data: any, slotType: string): IDndData {
    const {
      slot_id: slotId,
      courseGroupId = INVALID_ID,
      id: plannedCourseId = INVALID_ID,
      course_id: courseId = INVALID_ID
    } = _data;
    return {
      slotId,
      plannedCourseId,
      courseId,
      isFromTerm: true,
      slotType,
      courseGroupId
    };
  }
  insertCallback(event: any, index: number, dndData: IDndData, external: any, courseType: string) {
    if (_4.get(dndData, 'isFromTerm', false)) {
      this._isCourseSlot(dndData)
        ? this._removeCourseAndAddCourseToTerm(dndData)
        : this._removeCourseGroupAndAddCourseGroupToTerm(dndData);
    } else {
      if (this._isCourseSlot(dndData)) {
        this._addCourseToTerm(dndData).then((studentId: number) => {
          this.loadMmAcademicPlanCommand(studentId);
        });
      } else if (this._isGroupSlot(dndData)) {
        this._addCourseGroupToTerm(dndData).then((studentId: number) => {
          this.loadMmAcademicPlanCommand(studentId);
        });
      }
    }
  }

  private _isCourseSlot(genericSlot: { slotType: string }) {
    return (
      _4.eq(_4.get(genericSlot, 'slotType', ''), 'COURSE') ||
      _4.eq(_4.get(genericSlot, 'slotType', ''), 'DEV_REQ_COURSE')
    );
  }
  private _isGroupSlot(genericSlot: { slotType: string }) {
    return _4.eq(_4.get(genericSlot, 'slotType', ''), 'GROUP');
  }

  private _removeCourseGroupAndAddCourseGroupToTerm(data: IDndData) {
    const plannedCourseGroupId = _4.get(data, 'plannedCourseId', 0);
    this._removeCoursegroup(plannedCourseGroupId).then((studentId: number) => {
      this._addCourseGroupToTerm(data).then(() => {
        this.loadMmAcademicPlanCommand(studentId);
      });
    });
  }

  private _removeCoursegroup(plannedCourseGroupId: number) {
    return this.removeMmCourseGroupFromTermCommand(plannedCourseGroupId);
  }

  private _removeCourseAndAddCourseToTerm(data: IDndData) {
    const plannedCourseId = _4.get(data, 'plannedCourseId', 0);
    this._removeCourseFromTerm(plannedCourseId).then((studentId: number) => {
      this._addCourseToTerm(data).then(() => {
        this.loadMmAcademicPlanCommand(studentId);
      });
    });
  }

  private _removeCourseFromTerm(plannedCourseId: number) {
    return this.removeMmCourseFromTermCommand(plannedCourseId);
  }

  private _addCourseGroupToTerm(data: IDndData) {
    return this.saveMmCourseGroupToTermCommand(this._courseGroupPayload(data));
  }

  private _addCourseToTerm(data: IDndData) {
    return this.saveMmCourseToTermCommand(this._coursePayload(data));
  }

  initialize() {
    this.isEmptyTerm = _4.isEmpty(_4.get(this.term, 'statusGroups', []));
  }

  private _basepayload(data: IDndData) {
    const program_slot = _4.get(data, 'slotId', INVALID_ID);
    const term = _4.get(this.term, 'termId', INVALID_ID);
    return _4.gt(program_slot, 0)
      ? {
          term,
          program_slot
        }
      : { term };
  }
  private _coursePayload(data: IDndData) {
    return {
      ...this._basepayload(data),
      course: _4.get(data, 'courseId', INVALID_ID)
    };
  }
  private _courseGroupPayload(data: IDndData) {
    return {
      ...this._basepayload(data),
      course_group: _4.get(data, 'courseGroupId', INVALID_ID)
    };
  }
}

class TermBoxMmComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;
  constructor() {
    this.bindings = {
      term: '<',
      isEditable: '<?',
      isPast: '<?'
    };
    this.controller = TermBoxMm;
    this.templateUrl = 'capability-ng-academic-planner/src/plan/components/term_box/term_box_mm.html';
  }
}
angular.module('capability-ng-academic-planner').component('eabMyPlannerTermMmBox', new TermBoxMmComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/components/term_box/term_box_mm.ts